import {newLogger} from "../../../core/utils/logger";
import * as pageComments from "../pagecomments";
import * as sidebar from "../sidebar";

const logger = newLogger('Contest page');

export function init(options) {
	const o = {
		page: {},
		comments: [],
		...options
	};

	logger.log('init', o);

	pageComments.init({page: o.page, comments: o.comments});
	setTimeout(sidebar.init);
}



// WEBPACK FOOTER //
// ./modules/blog/page/contest.js